const Loader = () => {
  return (
    <div className="my-4 flex h-full items-center justify-center">
      <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-t-2 border-brand-600"></div>
    </div>
  );
};
export default Loader;
